import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Badge } from "../components/ui/badge";
import { Button } from "../components/ui/button";

export default function DashboardPage() {
  const [usage, setUsage] = useState(null);

  useEffect(() => {
    api.get("/api/me/usage").then((res) => setUsage(res.data));
  }, []);

  const isAdmin = usage?.is_admin || usage?.plan === "admin";
  const isTrial = !isAdmin && usage?.plan === "trial";
  const displayPlan = isAdmin ? "Admin" : usage?.plan || "—";

  return (
    <div className="space-y-6" data-testid="dashboard">
      <div>
        <div className="text-2xl font-semibold">Dashboard</div>
        <div className="text-sm text-muted-foreground">
          Your AI team is ready: Maya (Strategy), Cole (Creative), Coach River (Launch).
        </div>
      </div>

      {isTrial && (
        <Card className="border-amber-200 bg-amber-50">
          <CardHeader>
            <CardTitle className="flex items-center justify-between">
              Trial Mode <Badge variant="secondary">Export locked</Badge>
            </CardTitle>
          </CardHeader>
          <CardContent className="flex items-center justify-between gap-3">
            <div className="text-sm text-muted-foreground">
              Generate ads during your trial. Upgrade to unlock exporting and the Studio.
            </div>
            <Link to="/app/upgrade">
              <Button>Upgrade</Button>
            </Link>
          </CardContent>
        </Card>
      )}

      <div className="grid gap-4 md:grid-cols-3">
        <Card data-testid="plan-card">
          <CardHeader><CardTitle>Plan</CardTitle></CardHeader>
          <CardContent>
            <div className="text-xl font-medium">{displayPlan}</div>
            <div className="text-xs text-muted-foreground">Monthly & yearly available</div>
          </CardContent>
        </Card>

        <Card data-testid="credits-card">
          <CardHeader><CardTitle>Credits</CardTitle></CardHeader>
          <CardContent>
            <div className="text-xl font-medium">{usage?.credits ?? "—"}</div>
            <div className="text-xs text-muted-foreground">Used for generations & Studio</div>
          </CardContent>
        </Card>

        <Card data-testid="trial-card">
          <CardHeader><CardTitle>{isAdmin ? "Access" : "Trial"}</CardTitle></CardHeader>
          <CardContent>
            <div className="text-sm">
              {isAdmin
                ? "Owner bypass enabled"
                : usage?.trial_ends_at
                  ? `Ends: ${new Date(usage.trial_ends_at).toLocaleString()}`
                  : "—"}
            </div>
            <div className="text-xs text-muted-foreground">
              {isAdmin ? "All features and limits unlocked" : "Upgrade anytime"}
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="flex gap-3">
        <Link to="/app/ads"><Button data-testid="generate-ad-btn">Generate Meta Ad Pack</Button></Link>
        <Link to="/app/workspaces"><Button variant="outline" data-testid="manage-workspaces-btn">Manage Workspaces</Button></Link>
      </div>
    </div>
  );
}
